import React, { lazy } from "react";
import moment from 'moment';
import { LazyComponent } from "seed/helpers";
import ProfileIcon from "components/util/helpers/icons/ProfileIcon";
import l from "components/util/l";
import 'moment/locale/es';

const ReactApexChart = lazy(() => import("react-apexcharts"));
moment.locale('es');


const CollaborationListView = ({ collaboratorStats = [], showDetails = false, onClickCollaboratorDetail = () => { } }) => {

  const getChartData = (collaboratorStats) => {

    const statsLast7Days = collaboratorStats?.stats_last_7_days ?? {};

    const categories = (statsLast7Days?.messages_by_day ?? []).map(d => d.day);
    const messageCounts = (statsLast7Days?.messages_by_day ?? []).map(d => d.total);
    const executionCounts = (statsLast7Days?.executions_by_day ?? []).map(d => d.total);

    const maxVal = Math.max(...messageCounts, ...executionCounts, 1);
    const toPercentage = (value) => (value / maxVal) * 100;

    const absoluteValues = {
      messages: messageCounts,
      executions: executionCounts,
    };

    const series = [
      {
        name: "Mensajes",
        data: messageCounts.map(toPercentage)
      },
      {
        name: "Ejecuciones",
        data: executionCounts.map(toPercentage)
      },
    ];

    return { series, categories, absoluteValues };

  }

  return (
    <div id="start-activity-table" className="table-responsive">

      <table className="table table-borderless table-thead-bordered table-nowrap table-text-center table-align-middle card-table">
        <thead className="thead-light">
          <tr>
            <th scope="col" style={{ width: showDetails ? "27%" : "33%"}}>
              <div className="w-100 text-left mx-2">{l("Colaborador%SB025")}</div>
            </th>
            <th scope="col" style={{ width: showDetails ? "15%" : "17%" }}>{l("Mensajes%SB045")}</th>
            <th scope="col" style={{ width: showDetails ? "15%" : "17%" }}>{l("Ejecuciones%GA076")}</th>
            {showDetails && (
            <th scope="col" style={{ width: "33%" }}>{l("Últimos 7 días%SB032")}</th>
            )}
            {showDetails && (
              <th scope="col" style={{ width: "10%" }}>{l("Detalles%SB047")}</th>
            )}
          </tr>
        </thead>

        <tbody className="bg-white">
          {collaboratorStats.map((stats, index) => (
            <tr key={index}>
              <td className="py-1 font-weight-bold" style={{ maxWidth: showDetails ? "27%" : "30%", whiteSpace: "normal" }}>
                <div className="d-flex justify-content-left mx-2">
                  <div>
                    <ProfileIcon className="mr-2" style={{ width: "1.5rem", marginBottom: "0.15rem" }} />
                  </div>
                  <div className="text-truncate-2-lines">
                    {stats.user.first_name} {stats.user.last_name}<br />
                    <ul class="list-inline list-inline-m-1 mt-1 mb-0">
                      {stats.organizations.map((org, idx) => (
                        <li class="list-inline-item" key={org.id}>
                          {org.name} {idx < stats.organizations.length - 1 ? " / " : ""}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </td>
              <td style={{ maxWidth: showDetails ? "15%" : "17%", padding: "1.4rem 0.5rem" }}>{stats?.stats?.total_messages ?? "---"}</td>
              <td style={{ maxWidth: showDetails ? "15%" : "17%", padding: "1.4rem 0.5rem" }}>{stats?.stats?.total_executions ?? "---"}</td>
              {showDetails && (
              <td className="py-1" style={{ maxWidth: showDetails ? "33%" : "36%" }}>
                <div id="chart" style={{ height: "85px" }}>
                  {function () {
                    const { series, categories, absoluteValues } = getChartData(stats);
                    return <LazyComponent
                      options={
                        {
                          chart: {
                            height: 75,
                            type: 'line',
                            zoom: {
                              enabled: false
                            },
                            toolbar: {
                              show: false
                            },
                            padding: {
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0
                            }
                          },
                          dataLabels: {
                            enabled: false
                          },
                          stroke: {
                            curve: 'smooth',
                            width: 2
                          },
                          xaxis: {
                            labels: {
                              show: false
                            },
                            axisTicks: {
                              show: false
                            },
                            axisBorder: {
                              show: false
                            },
                            categories: categories,
                          },
                          yaxis: {
                            labels: {
                              show: false
                            },
                            axisTicks: {
                              show: false
                            },
                            axisBorder: {
                              show: false
                            }
                          },
                          grid: {
                            show: false,
                            padding: {
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0
                            }
                          },
                          tooltip: {
                            x: {
                              formatter: function (_, { dataPointIndex }) {
                                const dateStr = categories[dataPointIndex];
                                return moment(dateStr).format("dddd D MMMM").replace(/^\w/, c => c.toUpperCase());
                              },
                            },
                            y: {
                              formatter: function (_, { seriesIndex, dataPointIndex }) {
                                if (seriesIndex === 0) {
                                  return absoluteValues.messages[dataPointIndex];
                                } else if (seriesIndex === 1) {
                                  return absoluteValues.executions[dataPointIndex];
                                }
                                return 0;
                              },
                              title: {
                                formatter: (seriesName) => `${seriesName}`,
                              },
                            },
                          },
                          colors: ['#007bff', '#28a745'],
                          legend: {
                            show: false
                          }
                        }
                      }
                      series={series}
                      type="line"
                      height={75}
                      component={ReactApexChart}
                    />
                  }()}
                </div>
              </td>
              )}
              {showDetails && (
                <td className="py-2" style={{ maxWidth: "10%" }}>
                  <button className="btn btn-link btn-sm" onClick={() => onClickCollaboratorDetail(stats.user.id)}>
                    <i class="fas fa-eye mr-1"></i> {l("Detalle%SB048")}
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

}


export default CollaborationListView;
